export default __webpack_public_path__ + "assets/customer-support.b29867df.svg";